<template>
    <div class="relative">
        <img :src="src" style="width: 100%; height: 100%; object-fit: contain; z-index: 10" alt="" />
        <img
            :src="avatar"
            style="position: absolute; mask-size: contain; border-radius: 9999px"
            :style="avatarStyle"
            class="top-0"
            alt=""
        />
    </div>
</template>

<script>
export default {
    name: 'GamificationCostume',
};
</script>
<script setup>
import { ref } from 'vue';

let props = defineProps({
    avatar: {
        required: true,
        type: String,
    },
    costume: {
        required: true,
        type: Object,
    },
});

const src = ref(props.costume.image_path);
const size = ref(props.costume.size);
const translateX = ref(props.costume.translateX);
const translateY = ref(props.costume.translateY);
const avatarStyle = ref({
    width: `${size.value}%`,
    height: `${size.value}%`,
    transform: `translate(${translateX.value}%, ${translateY.value}%)`,
});
</script>
